<lib-punchout-form
  [checkoutObject]="checkout"
  (ready)="onPunchoutFormReady()"
  (failed)="onPunchoutFormFailed($event)"
></lib-punchout-form>

<div class="container py-5 text-center" *ngIf="!orderSubmitError.show">
  <div class="progress mt-10">
    <div
      class="progress-bar progress-bar-striped progress-bar-animated bg-primary"
      role="progressbar"
      aria-valuenow="75"
      aria-valuemin="0"
      aria-valuemax="100"
      style="width: 75%"
    ></div>
  </div>
  <h2 class="mt-3" translate>SUBMITTING_ORDER</h2>
</div>

<div class="container py-5" *ngIf="orderSubmitError.show">
  <div class="alert alert-danger" role="alert">
    {{ orderSubmitError.error | json }}
  </div>
</div>
